<template>
  <div>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            v-model="selectedDate"
            v-bind="attrs"
            v-on="on"
            placeholder="Letzte 3 Monate"
            readonly
            hide-details
            class="date-placeholder mt-0 pt-0"
        >
          <template #append>
            <div class="icon-kalender"
                 v-bind="attrs"
                 v-on="on" v-if="!selectedDate"></div>
            <div class="icon-schliessen-klein clear-all"
                 @click="selectedDate = null"
                 v-if="selectedDate"></div>
          </template>
        </v-text-field>
      </template>

      <v-date-picker
          v-model="dates"
          range
          :min="minDate"
          :max="maxDate"
          class="history-date-picker"
      />
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "HistoryDatePicker",

  props: {
    value: {
      type: Array | null,
      required: true,
    },
    minDate: {
      type: String,
      required: false,
      default: null
    },
    maxDate: {
      type: String,
      required: false,
      default: null
    },
  },

  data() {
    return {
      menu: false,
      dates: null,
    }
  },

  computed: {
    selectedDate: {
      get() {
        if (this.dates && this.dates.length == 2) {
          if(moment(this.dates[1]).isBefore(moment(this.dates[0]))) {
          let tmp = this.dates.splice(0,1);
          this.dates.push(tmp[0]);
          }
          return moment(this.dates[0]).format('DD.MM.YYYY') + ' - ' + moment(this.dates[1]).format('DD.MM.YYYY')
        }
        else if(this.dates && this.dates.length == 1){
          return moment(this.dates[0]).format('DD.MM.YYYY') + " - wählen";
        }
      },
      set(value) {
        this.dates = value;
      }
    }
  },

  methods: {
    close() {
      this.menu = false;
    }
  },

  watch: {
    value(value) {
      if (this.value) {
        this.dates = this.value
      }
    },

    dates(value) {
      if (value && value.length > 1) {
        this.$emit('input', value)
        this.close()
      } else if (value === null) {
        this.$emit('input', null)
      }
    }
  },

  mounted() {
    if (this.value) {
      this.dates = this.value
    }
  }
}
</script>

<style lang="scss" scoped>
.clear-all {
  position: relative;
  cursor: pointer;
  z-index: 9;
  font-size: 12px;
  line-height: 22px;

  &:hover {
    color: #ce20a8;
  }
}
</style>
